import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { CheggSVG, SVGFill } from '../../svg';
import colors from '../../colors';
import { UVERSITY } from './../shared';
var UversityLogo = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$svgColor = _ref.svgColor,
      svgColor = _ref$svgColor === void 0 ? 'currentColor' : _ref$svgColor,
      role = _ref.role,
      rest = _objectWithoutProperties(_ref, ["svgColor", "role"]);

  return /*#__PURE__*/React.createElement(CheggSVG, _extends({
    "aria-label": UVERSITY,
    ref: ref,
    viewBox: "0 0 140 40",
    svgColor: svgColor,
    role: role
  }, rest), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SVGFill, {
    svgColor: colors.cheggOrange,
    d: "M16.93,1.02h6.72v18.63c0,6.83-4.86,11.35-11.86,11.35C4.77,30.99,0,26.48,0,19.66V1.02h6.82v18.65 c0,3.11,2.23,5.23,5.2,5.23c2.82,0,4.91-1.89,4.91-5.23V1.02z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    svgColor: colors.dark,
    d: "M71.05,30.5h-5.72V9.74h4.55l0.38,2.08c0,0,3.47-3.7,8.76-2.03l-1.05,5.55c0,0-2.32-1.05-4.73,0.41 c0,0-2.18,1.15-2.18,4.8V30.5z M103.58,9.72H107V3.79l5.76-0.96v6.89l4.11,0v5.39h-4.12l0,6.35c0,4.2,1.81,4.81,4.71,4.97l-0.93,4.69 c-4.86-0.23-9.51-2.26-9.51-8.19v-7.82h-3.42V9.72z M134.08,9.72H140l-9.6,23.66c-1.83,4.27-4.66,5.55-7.55,5.73c-1.59,0.1-2.67,0.08-4.55-0.28l0.99-4.9 c0.88,0.13,1.81,0.24,2.43,0.19c1.7-0.14,2.29-0.57,3.22-2.27l0.61-1.28l-7.88-20.85h6.2l4.91,14.02L134.08,9.72z M53.86,9.11c-5.75,0-10.25,4.8-10.25,10.94c0,6.03,4.76,10.94,10.62,10.94c5.46,0,8.29-3.93,8.78-4.68 l-3.62-2.48c-1.33,1.45-2.98,2.06-5.17,1.94c-0.96-0.05-1.92-0.37-2.7-0.9c-0.85-0.58-1.45-1.36-1.72-2.28l-0.06-0.21H63.9 c0.05-0.34,0.16-1.27,0.16-2.34C64.06,13.92,59.58,9.11,53.86,9.11z M49.2,18.43l0.02-0.18c0.13-1.29,0.71-2.46,1.63-3.3 c0.89-0.81,2-1.25,3.14-1.25c2.26,0,4.74,1.6,4.91,4.56l0.01,0.17H49.2z M35.1,23.53l4.3-13.79h6l-7.43,20.8h-5.72l-7.82-20.8h6.07L35.1,23.53z M86.43,26.03c1.91,0.14,3.64-0.23,3.64-1.6c0-3-10.93-1.76-10.93-8.76c0-4.26,3.66-6.69,8.01-6.69 c3.21,0,5.88,0.96,7.8,2.4l-2.35,3.86c-1.53-0.96-2.87-1.6-5.25-1.6c-1.63,0-2.84,0.62-2.84,1.65c0,3.6,10.92,1.3,10.92,8.84 c0,4.41-3.62,6.67-8.44,6.67c-3.41,0-6.09-1.33-8.57-3.28l2.39-3.74C82.62,24.99,84.32,25.88,86.43,26.03z M96.59,9.72h5.73V30.5h-5.73V9.72z M96.15,3.44a3.44,3.44 0 1,0 6.88,0a3.44,3.44 0 1,0 -6.88,0"
  })));
});
UversityLogo.displayName = 'UversityLogo';
export default UversityLogo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/CheggLogo/variants/UversityLogo.js
// module id = 1035
// module chunks = 12